export function getJWT() {
  const tokenString = localStorage.getItem('token');
  if (!tokenString) return null;
  
  const userToken = JSON.parse(tokenString);
  return userToken?.token || null;
}

export function isAdmin() {
  const tokenString = localStorage.getItem('token');
  if (!tokenString) return false;
  
  const userToken = JSON.parse(tokenString);
  const token = userToken?.token;
  
  if (token && token.startsWith('eyJ')) {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      const decoded = JSON.parse(jsonPayload);
      return decoded.isAdmin === true;
    } catch (e) {
      console.error("JWT decode error:", e);
      return false;
    }
  }
  
  return false;
}

export function getJWTWithFallback() {
  const jwt = getJWT();
  if (jwt) return jwt;
  
  return null;
}
